import { useCallback } from "react";
import {
  registerMessageElement,
  registerVersionElement,
} from "./scroll-controller-registration";
import type { ScrollActions } from "./use-scroll-actions";
import type { ScrollControllerRefs } from "./use-scroll-controller-refs";

export interface ScrollElementRegistration {
  registerMessageEl: (messageId: string, el: HTMLElement | null) => void;
  registerVersionEl: (versionShortId: string, el: HTMLElement | null) => void;
}

interface UseScrollElementRegistrationInput {
  refs: ScrollControllerRefs;
  actions: ScrollActions;
}

export function useScrollElementRegistration({
  refs,
  actions,
}: UseScrollElementRegistrationInput): ScrollElementRegistration {
  const registerMessageEl = useCallback(
    (messageId: string, el: HTMLElement | null) => {
      registerMessageElement({
        messageId,
        el,
        messageElementsRef: refs.messageElementsRef,
        elementToMessageIdRef: refs.elementToMessageIdRef,
        visibleMessageIdsRef: refs.visibleMessageIdsRef,
        observerRef: refs.observerRef,
        pendingScrollRef: refs.pendingScrollRef,
        scrollToMessageId: actions.scrollToMessageId,
      });
    },
    [refs, actions],
  );

  const registerVersionEl = useCallback(
    (versionShortId: string, el: HTMLElement | null) => {
      registerVersionElement({
        versionShortId,
        el,
        versionElementsRef: refs.versionElementsRef,
        pendingScrollRef: refs.pendingScrollRef,
        scrollToVersionId: actions.scrollToVersionId,
      });
    },
    [refs, actions],
  );

  return {
    registerMessageEl,
    registerVersionEl,
  };
}
